import { defineComponent, h } from 'vue';
import { InspectionActivity } from '@/entities/activity/model';
import { createdAt } from '@/ui/components/activityLogs/common/CreatedAt';
import { t } from '@/ui/i18n/i18n';
import { boldifyStringArray } from '@/ui/components/activityLogs/helpers';
import { InspectionActivitiesProps } from '@/ui/components/activityLogs/types';

type AvailableProps = InspectionActivitiesProps<InspectionActivity>;

export const Available = defineComponent<AvailableProps>({
  name: 'Available',
  props: ['resourceName', 'log'],
  setup(props) {
    return function render() {
      return h('div', { class: 'activity-logs__log' }, [
        createdAt({ props: { log: props.log } }),
        h('span', {
          domProps: {
            innerHTML: t('activity-logs.inspection-available', {
              // @ts-ignore
              username: boldifyStringArray(props.log.payload.map(user => user.name)),
            }),
          },
        }),
      ]);
    };
  },
});
